// src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import AuthProvider from './context/AuthContext';
import TeamProvider from './context/TeamContext';
import { RoleProvider } from './context/RoleContext';
import { NotificationProvider } from './context/NotificationContext';
import './index.css';
import './i18n';

/* -------------------------------------------
   FIRESTORE ASSERTION CRASH RECOVERY
   The Firestore SDK (11.x) has a known bug where the internal WebChannel
   state machine gets stuck (IDs ca9 / b815) after a network interruption.
   It cannot self-recover — the only fix is a page reload. We debounce so
   rapid cascading errors only trigger one reload in a 10-second window.
--------------------------------------------*/
let _firestoreReloadScheduled = false;
window.addEventListener('unhandledrejection', (event) => {
  const msg = event.reason?.message || '';
  if (msg.includes('FIRESTORE') && msg.includes('INTERNAL ASSERTION FAILED')) {
    event.preventDefault();
    if (!_firestoreReloadScheduled) {
      _firestoreReloadScheduled = true;
      console.warn('[Scrimly] Firestore assertion error — reloading to recover.', msg.slice(0, 120));
      setTimeout(() => window.location.reload(), 1500);
    }
  }
});

/* -------------------------------------------
   APP BOOTSTRAP
--------------------------------------------*/
const rootEl = document.getElementById('root');

if (rootEl) {
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <TeamProvider>
            {/* RoleProvider depends on Auth + Team for input
                (userProfile.role + the user's coach team list), and
                must sit inside Router because it reads URL via
                useLocation. Anything below it can call useRole(). */}
            <RoleProvider>
              <NotificationProvider>
                <App />
              </NotificationProvider>
            </RoleProvider>
          </TeamProvider>
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}

/* -------------------------------------------
   Register service worker for FCM
--------------------------------------------*/
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js', { scope: '/' })
      .catch((err) => {
        // Silent fail in production
      });
  });
}